module.exports = __webpack_public_path__ + "img/蛋糕.698f9248.png";